// Auth Context Provider
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { initializeAuth, logout as logoutAction, setUser, loginApi } from '../../store/actions/loginAction';
import { clearPermissions } from '../../store/actions/permissionsAction';
import { AuthContext } from './AuthContext';

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, token, apiState } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize auth from localStorage
    dispatch(initializeAuth());
    setLoading(false);
  }, [dispatch]);

  const login = async (credentials) => {
    dispatch(loginApi(credentials));
    // The login state will be updated via Redux, components should use useSelector
    return { success: true };
  };

  const logout = async () => {
    dispatch(logoutAction());
    dispatch(clearPermissions());
  };

  const updateUser = (userData) => {
    dispatch(setUser(userData));
  };

  const value = {
    user,
    isAuthenticated,
    token,
    loading: loading || apiState === 'loading',
    login,
    logout,
    updateUser,
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;

